import { createAction, props } from '@ngrx/store';
import { ChargepointSummaryItem } from 'brain-data/model/chargepoint.model';

export const loadChargepointSummary = createAction('[Chargepoint] Load Summary', props<{ fromTimeStamp: string; toTimeStamp: string }>());

export const loadChargepointSummarySuccess = createAction('[Chargepoint] Load Summary Success', props<{ summary: ChargepointSummaryItem[] }>());

export const loadChargepointSummaryError = createAction('[Chargepoint] Load Summary Error', props<{ error: Error }>());

export const setChargepointDataFromJson = createAction('[Chargepoint] Set Data From JSON', props<{ summary: ChargepointSummaryItem[] }>());
